import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import ResultComponent from '../components/Results';

class ResultsPage extends Component {
  static propTypes = {
    results: PropTypes.array.isRequired
  }

  static defaultProps = {
    results: []
  }

  render() {
    const results = this.props.results;
    //console.log(results);
    return (
      <ResultComponent data={ results } />
      );
  }
}

ResultsPage = connectToStores(ResultsPage, ['ResultsStore'], (stores, props) => {
  return {
    results: stores.ResultsStore.get()
  };
});

export default ResultsPage;



// WEBPACK FOOTER //
// ./src/pages/ResultsPage.js